import { useRouter } from "next/router";
import LearningModulesContext from "./LearningModulesContext";

function LearningModulesProvider({
  children,
  learningModules,
  learningModule,
  journalEntries,
  allQuestions,
}: any) {
  return (
    <LearningModulesContext.Provider
      value={{ learningModules, allQuestions, learningModule, journalEntries }}
    >
      {children}
    </LearningModulesContext.Provider>
  );
}

export default LearningModulesProvider;
